/* eslint-disable max-lines */
/* eslint-disable radix */
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable max-statements*/
/* eslint-disable no-negated-condition*/
/* eslint-disable no-use-before-define*/
/* eslint-disable xss/no-mixed-html*/
ACC.myQuotations = {
  quoteDetails: '.ph-quotedetails',
  hiddenCls: 'hidden',
  checkOnlyIfPriceDiv: function(quoteId) {
    var leftColumnCls = '.ph-quote-leftcol' + quoteId,
        priceContentCls = 'ph-quote-pricecontent' + quoteId;

    if ($(leftColumnCls).children().length === 1 && $(leftColumnCls).children('div').hasClass(priceContentCls)) {
      $(leftColumnCls).hide();
    } else {
      $('.' + priceContentCls).hide();
    }
  },
  collapseQuote: function(upArrowCls, downArrowCls) {
    $('.ph-quote_foldouts').each(function() {
      if ($(this).hasClass('active')) {
        $(this).addClass(ACC.myQuotations.hiddenCls);
        $(this).removeClass('active');
      }
    });
    $(ACC.myQuotations.quoteDetails).each(function() {
      if ($(this).hasClass('arrow')) {
        $(this).removeClass(upArrowCls).addClass(downArrowCls);
        $(this).removeClass('arrow');
      }
    });
  },
  openFoldOut: function(functParam) {
    $(functParam.quoteDetails + functParam.quoteId).find('.' + functParam.loadeIconCls).hide();
    $(functParam.foldOutCls + functParam.quoteId).toggleClass(functParam.hiddenCls);
    $(functParam.quoteDetails).removeClass(functParam.disableButton);
    $(functParam.quoteDetails + functParam.quoteId).addClass(functParam.upArrowCls);
    ACC.myQuotations.checkOnlyIfPriceDiv(functParam.quoteId);
    $(functParam.foldOutCls + functParam.quoteId).find('.ph-hide-price').hide();
    ACC.myQuotations.collapseQuote(functParam.upArrowCls, functParam.downArrowCls);
    $(functParam.foldOutCls + functParam.quoteId).addClass(functParam.active);
    $(functParam.quoteDetails + functParam.quoteId).addClass(functParam.arrow);
    $(functParam.quoteDetails + functParam.quoteId).parent(functParam.quoteoverview).addClass(functParam.panelactive);
  },
  formatItemLevelPrice: function(itemLevelPrice, priceWithoutCurrency) {
    var finalPrice = '';

    if (priceWithoutCurrency.includes(',')) {
      finalPrice = itemLevelPrice.toString().replace('.', ',');
    } else {
      finalPrice = itemLevelPrice;
    }

    return finalPrice;
  },
  getQuotePrice: function(priceList) {
    var quoteprice = 0,
        priceIndx = 0;

    for (priceIndx; priceIndx < priceList.length; priceIndx = priceIndx + 1) {
      if (priceList[priceIndx].priceType === 'BUY' && priceList[priceIndx].pricingConditionCode !== 'YLRR') {
        quoteprice = priceList[priceIndx];
      }
    }

    return quoteprice;
  }
};
$(document).ready(function() {
  var loadeIconCls = 'ph-quote-loader',
      foldOutCls = '.ph-quote_foldouts',
      hiddenCls = 'hidden',
      active = 'active',
      arrow = 'arrow',
      quoteDetails = ACC.myQuotations.quoteDetails,
      disableButton = 'ph-disable_quote_buttons',
      panelactive = 'ph-panelactive',
      hidePriceCls = 'ph-hide-price',
      priceContentCls = 'ph-quote-pricecontent',
      quoteoverview = '.ph-quote_overview';

  function getProductCodesForPrice(quoteId) {
    var productCodes = [],
        code = '',
        productRows = $(foldOutCls + quoteId).find('.ph-quote-productrows');

    $(productRows).each(function() {
      code = $(this).attr('data-productcode');
      productCodes.push(code);
    });

    return productCodes;
  }

  function calculatePrice(result, quoteId) {
    var qty = 0,
        totalPrice = 0,
        priceWithCurreny = '',
        finalPriceWithCurrency = '',
        finalTotalPriceWithCurrency = '',
        totalPricePattern = '',
        itemLevelPrice = 0,
        unitPrice = 0,
        varYdnc = '',
        priceList = '',
        priceIndx = 0,
        priceRow = '',
        count = 0,
        countYdnc = 0,
        quoteStr = '#ph-quoteexp' + quoteId,
        quoteAccBtnStr = ' #ph-quote__accbutton';


    for (priceIndx; priceIndx < result.length; priceIndx = priceIndx + 1) {
      priceList = result[priceIndx].priceList;

      qty = parseInt($(foldOutCls + quoteId).find('.ph-quote-qty' + result[priceIndx].code + '-' + priceIndx).first().text());
      unitPrice = ACC.myQuotations.getQuotePrice(priceList);
      itemLevelPrice = qty * unitPrice.value;
      totalPricePattern = unitPrice.formattedValue;
      priceWithCurreny = addCurrencySymbol(result[priceIndx].priceList[0].formattedValue, itemLevelPrice);
      finalPriceWithCurrency = ACC.myQuotations.formatItemLevelPrice(priceWithCurreny, result[priceIndx].priceList[0].priceWithoutCurrency);
      $(foldOutCls + quoteId).find('.ph-quote-itemprice' + result[priceIndx].code + '-' + priceIndx).text(finalPriceWithCurrency);
      $(foldOutCls + quoteId).find('.ph-quote-unitprice' + result[priceIndx].code + '-' + priceIndx).text(totalPricePattern);
      totalPrice = totalPrice + itemLevelPrice;

      for (count; count < priceList.length; count = count + 1) {
        priceRow = priceList[count];

        varYdnc = priceRow.pricingConditionCode;

        if (varYdnc === 'YDNC') {
          countYdnc = countYdnc + 1;

          break;
        }
      }
    }

    if (countYdnc === result.length) {
      $(quoteStr + ' .ph-quote__decbutton').removeClass('disabled');

      if ($('.ph-sap-orderBlock').length > 0 || $('.ph-storeclosed').val() === 'true') {
        $(quoteStr + quoteAccBtnStr).addClass('disabled');
      } else {
        $(quoteStr + quoteAccBtnStr).removeClass('disabled');
      }

      $(foldOutCls + quoteId).find('.' + hidePriceCls).show();
      $(foldOutCls + quoteId).find('.' + priceContentCls + quoteId).show();
    } else {
      $(quoteStr + ' .ph-quote__decbutton').addClass('disabled');
      $(quoteStr + quoteAccBtnStr).addClass('disabled');
      $(quoteStr + ' .ph-quoteprice-warn').show();
      $(foldOutCls + quoteId).find('.' + hidePriceCls).hide();
      $(foldOutCls + quoteId).find('.' + priceContentCls + quoteId).hide();
    }

    priceWithCurreny = addCurrencySymbol(totalPricePattern, totalPrice);
    finalTotalPriceWithCurrency = ACC.myQuotations.formatItemLevelPrice(priceWithCurreny, totalPricePattern);
    $(foldOutCls + quoteId).find('.ph-quote-totalprice').text(finalTotalPriceWithCurrency);
  }

  function getPriceDataForProducts(productcode, quoteId, quoteState) {
    var maxbothWidth = 0,
        upArrowCls = 'ph-icon-arrow-up',
        downArrowCls = 'ph-icon-arrow-down',
        functParam = {
          quoteId: quoteId,
          loadeIconCls: loadeIconCls,
          quoteDetails: quoteDetails,
          foldOutCls: foldOutCls,
          hiddenCls: hiddenCls,
          disableButton: disableButton,
          upArrowCls: upArrowCls,
          downArrowCls: downArrowCls,
          active: active,
          arrow: arrow,
          quoteoverview: quoteoverview,
          panelactive: panelactive
        };

    if (quoteState === 'QUOTE_READY') {
      ACC.decisionPageInfiniteLoader.getPriceData(productcode, function(result) {
        calculatePrice(result, quoteId);
        $(quoteDetails + quoteId).find('.' + loadeIconCls).hide();
        $(quoteDetails).removeClass(disableButton);
        $(foldOutCls + quoteId).toggleClass(hiddenCls);
        $(quoteDetails + quoteId).addClass(upArrowCls);
        ACC.myQuotations.collapseQuote(upArrowCls, downArrowCls);
        $(foldOutCls + quoteId).addClass(active);
        $(quoteDetails + quoteId).addClass(arrow);
        $(quoteDetails + quoteId).parent(quoteoverview).addClass(panelactive);
        $('.ph-spacequote').each(function() {
          maxbothWidth = Math.max(maxbothWidth, $(this).width());
        }).width(maxbothWidth);
      }, function() {
        ACC.myQuotations.openFoldOut(functParam);
        $(foldOutCls + quoteId).find('.ph-quoteprice-error').removeClass(hiddenCls);
        $(foldOutCls + quoteId).find('.ph-quotebtn-parent').hide();
      });
    } else {
      ACC.myQuotations.openFoldOut(functParam);
    }
  }

  function addCurrencySymbol(formattedPrice, priceValue) {
    var priceFormatted = formattedPrice.replace(',', '.'),
        priceWithCurrency = '',
        currencySymbol = '',
        priceArr = '';

    /* eslint-disable no-useless-escape */
    priceFormatted = priceFormatted.toString().replace(/\s/g, '-');
    currencySymbol = formattedPrice.toString().replace(/[\d\., ]/g, '');
    priceArr = priceFormatted.split('-');
    /* eslint-enable no-useless-escape */

    if (isNaN(priceArr[0])) {
      priceWithCurrency = currencySymbol + ' ' + parseFloat(priceValue).toFixed(2).toString();
    } else {
      priceWithCurrency = parseFloat(priceValue).toFixed(2).toString() + ' ' + currencySymbol;
    }

    return priceWithCurrency;
  }

  $(document).on('click', '.ph-quotedetails', function() {
    var atrQuoteId = 'quoteid',
        quoteId = $(this).attr('data-' + atrQuoteId),
        quoteState = $(this).attr('data-quotestate'),
        upArrowCls = 'ph-icon-arrow-up',
        downArrowCls = 'ph-icon-arrow-down',
        prodCode = '';


    if ($(quoteDetails + quoteId).hasClass(downArrowCls)) {
      $(quoteDetails + quoteId).removeClass(downArrowCls);
      $(quoteDetails).addClass(disableButton);
      $(this).find('.ph-quote-loader').show();
      prodCode = getProductCodesForPrice(quoteId);
      $(quoteoverview).removeClass(panelactive);
      getPriceDataForProducts(prodCode.toString(), quoteId, quoteState);
    } else {
      $(foldOutCls + quoteId).addClass(hiddenCls);
      $(quoteDetails + quoteId).removeClass(upArrowCls).addClass(downArrowCls);
      $(foldOutCls + quoteId).removeClass(active);
      $(quoteDetails + quoteId).removeClass(arrow);
      $(quoteDetails + quoteId).parent(quoteoverview).removeClass(panelactive);
      $(quoteoverview).removeClass(panelactive);
    }
  });

  $(document).on('keyup', '.ph-return-qtybox-quote', function() {
    var quantity = Number($(this).val());

    if (!quantity) {
      quantity = 0;
      $(this).val(quantity);
    } else {
      $(this).val(quantity);
    }
  });

  $(document).on('change', '.ph-return-qtybox-quote', function() {
    var maxQuantity = $(this).attr('max'),
        minQuantity = $(this).attr('min'),
        btn = 'button',
        disablebtn = 'ph-disable-' + btn,
        qtyplusbutton = '.ph-quote_qtyplus',
        qtyminusbutton = '.ph-quote_qtyminus',
        quantity = Number($(this).val()),
        contentUnit = Number($(this).attr('data-min'));

    if (!quantity) {
      quantity = contentUnit;
      $(this).val(quantity);
    } else {
      quantity = ACC.autocomplete.roundqty(quantity, contentUnit);
      $(this).val(quantity);
    }

    if (parseInt($(this).val()) >= parseInt(maxQuantity)) {
      $(this).siblings(qtyplusbutton).addClass(disablebtn);
      $(this).val(maxQuantity);
    } else {
      $(this).siblings(qtyplusbutton).removeClass(disablebtn);
    }

    if (parseInt($(this).val()) > parseInt(minQuantity)) {
      $(this).siblings(qtyminusbutton).removeClass(disablebtn);
    } else {
      $(this).siblings(qtyminusbutton).addClass(disablebtn);
    }
  });

  $(document).on('click', '#ph-updateQuoteDetailsForm .ph-list_plusminus', function() {
    var selreturnqtyid = '',
        qtyminus = 0,
        maxqty = 0,
        minqty = 0,
        btn = 'button',
        disablebtn = 'ph-disable-' + btn,
        qtyplusbutton = '.ph-quote_qtyplus',
        qtyminusbutton = '.ph-quote_qtyminus',
        contentUnit = 0;

    if ($(window).width() > 600) {
      selreturnqtyid = '.ph-quote-deskView .ph-return-qtybox-quote';
    } else {
      selreturnqtyid = '.ph-quote-mobView .ph-return-qtybox-quote';
    }

    qtyminus = $(this).siblings(selreturnqtyid).val();
    maxqty = parseInt($(this).siblings(selreturnqtyid).attr('max'));
    minqty = parseInt($(this).siblings(selreturnqtyid).attr('min'));
    contentUnit = Number($(this).attr('data-min'));

    if ($(this).hasClass('ph-quote_qtyminus')) {
      if (parseInt(qtyminus) !== contentUnit) {
        $(this).siblings(selreturnqtyid).val(parseInt(qtyminus) - contentUnit);
      }

      $(this).siblings(qtyplusbutton).removeClass(disablebtn);

      if (parseInt(qtyminus) - contentUnit === minqty) {
        $(this).addClass(disablebtn);
      } else {
        $(this).removeClass(disablebtn);
      }
    } else if ($(this).hasClass('ph-quote_qtyplus')) {
      if (parseInt(qtyminus) <= maxqty) {
        $(this).siblings(selreturnqtyid).val(parseInt(qtyminus) + contentUnit);
      }

      $(this).siblings(qtyminusbutton).removeClass(disablebtn);

      if (parseInt(qtyminus) + contentUnit === maxqty) {
        $(this).addClass(disablebtn);
      } else {
        $(this).removeClass(disablebtn);
      }
    }
  });

  function createNewOrder(quoteId) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/quote/addQuoteProductsToCart',
      data: {
        quoteId: quoteId
      },
      type: 'POST',
      datatype: 'json',
      success: function() {
        window.location = ACC.config.encodedContextPath + '/checkout';
      },
      error: function() {
        $.colorbox.close();
      }
    });
  }

  $(document).on('click', '.ph-quote__accbutton', function() {
    var atrQuoteId = 'quoteid',
        quoteId = $(this).attr('data-' + atrQuoteId),
        urlLink = window.location.href,
        trigger = 'linkCategory.clickAcceptQuotation',
        compname = 'ph-quote__accbutton',
        desc = $.trim($(this).text()) + ' - ' + quoteId,
        userEventObj = '';

    if ($('.quantity-balloon').length > 0) {
      $.colorbox({
        maxWidth: '630px',
        width: '95%',
        height: 'auto',
        scrolling: true,
        html: $('.ph-shoppingcartswich_popup' + quoteId).html(),
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    } else {
      $(this).addClass(disableButton);
      $(this).children().removeClass(hiddenCls);
      createNewOrder(quoteId);
    }

    userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });


  $(document).on('click', '.ph-proceed_quote', function() {
    var atrQuoteId = 'quoteid',
        quoteId = $(this).attr('data-' + atrQuoteId);

    $(this).addClass(disableButton);
    $(this).prev().addClass(disableButton);
    $(this).children().removeClass(hiddenCls);


    createNewOrder(quoteId);
  });
  $(document).on('click', '.ph-cancel_quote, .ph-stay_quote', function() {
    $.colorbox.close();
  });

  $(document).on('click', '.ph-backtocart_quote', function() {
    $.colorbox({
      width: '500px',
      maxWidth: '90%',
      height: '200px',
      html: $('.ph-CancelPopup').html(),
      overlayClose: false,
      onComplete: function() {
        $('#cboxContent .ph-confirmbackto_quote').attr('data-navurl', '/quote');
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });
  $(document).on('click', '.ph-backto_pageselected', function(event) {
    var url = $(this).attr('href'),
        focCartValue = $('.ph-isfocCart').val();

    event.preventDefault();

    if ($('.checkout_isZoomCart').val() === 'true') {
      PHI.common.showzoomDeliveredPopUp(url);
    } else if (focCartValue === 'true') {
      PHI.common.showFocPopUp(url);
    } else if ($('body').hasClass('page-quoteCheckoutSummaryPage') || $('.ph-quoteIdFromSession').length > 0) {
      ACC.common.showQuotePopUp(url);
    } else if ($('body').hasClass('page-merchandiseCheckout')) {
      ACC.common.showMerchPopUp(url);
    }

    return false;
  });
  $(document).on('click', '.ph-confirmbackto_quote', function() {
    var navUrl = $(this).attr('data-navurl');

    $.ajax({
      url: ACC.config.encodedContextPath + '/quote/clearQuoteCart',
      type: 'GET',
      datatype: 'json',
      success: function() {
        $.colorbox.close();

        if (navUrl === '/quote' || navUrl === 'search') {
          window.location = ACC.config.encodedContextPath + '/quote';
        } else if (navUrl === 'merchandise') {
          window.location = ACC.config.encodedContextPath + '/merchandise/newMerchandiseCategory';
        } else {
          window.location = navUrl;
        }
      },
      error: function() {
        $('.ph-RemoveProduct').html('');
        $.colorbox.close();
      }
    });
  });
});

$(document).on('click', '.ph-quote-del', function() {
  var proId = $(this).attr('data-attr'),
      quoteRadioStr = '.ph-quoteRadioHead-add',
      inputStr = 'Input',
      $quoteDiv = $('.ph-quote' + inputStr),
      quoteNxtStr = ' .ph-quote-next',
      shoppinglistrow = 'myshopping-list-row';

  $('#row' + proId).remove();

  if ($quoteDiv.val() !== '') {
    if ($(quoteRadioStr + ' .ph-' + shoppinglistrow).length > 0) {
      $(quoteRadioStr + quoteNxtStr).removeClass('disabled');
    } else {
      $(quoteRadioStr + quoteNxtStr).addClass('disabled');
    }
  }
});

$(document).on('click', '#ph-quoteRadioadd', function() {
  var quoteHeadString = '.ph-quoteRadioHead-';

  $(quoteHeadString + 'add').removeClass('hidden');
  $(quoteHeadString + 'describe').addClass('hidden');
});

$(document).on('click', '#ph-quoteRadiodescribe', function() {
  var quoteHeadStr = '.ph-quoteRadioHead';

  $(quoteHeadStr + '-describe').removeClass('hidden');
  $(quoteHeadStr + '-add').addClass('hidden');
});

$(document).on('click', '#ph-quote-next-btn', function() {
  var quoteHeadStr = '.ph-quoteRadioHead',
      inputStr = 'Input',
      $quoteDiv = $('.ph-quote' + inputStr),
      $IdquoteDivInput = $('#ph-quoteInput-field'),
      formField = 'ph-form_field_error';

  if ($quoteDiv.val() === '') {
    $($IdquoteDivInput + ' .ph-signup__error').addClass(formField);
    $($IdquoteDivInput + ' .ph-contactperson__emptyvalue').removeClass('hidden');
  } else {
    $('.ph-quotesearch-head').addClass('hidden');
    $(quoteHeadStr + '-add').addClass('hidden');
    $(quoteHeadStr + '-describe').removeClass('hidden');
    $(quoteHeadStr + '-describe .ph-quote-cancel').addClass('hidden');
    $(quoteHeadStr + '-describe .ph-quote-back').removeClass('hidden');
    $($IdquoteDivInput + ' .ph-signup__error').removeClass(formField);
    $($IdquoteDivInput + ' .ph-contactperson__emptyvalue').addClass('hidden');
  }
});

$(document).on('click', '#ph-quote-back-btn', function() {
  var quoteHeadString = '.ph-quoteRadioHead-';

  $('.ph-quotesearch-head').removeClass('hidden');
  $(quoteHeadString + 'add').removeClass('hidden');
  $(quoteHeadString + 'describe').addClass('hidden');
  $(quoteHeadString + 'describe .ph-quote-cancel').removeClass('hidden');
  $(quoteHeadString + 'describe .ph-quote-back').addClass('hidden');
});

$(document).on('click', '#ph-quote-cancel', function() {
  var shoppinglistrow = '#ph-updateQuoteDetailsForm .product-container .ph-myshopping-list-row';

  $('.ph-quote__reqbutton').removeClass('hidden');
  $('.ph-specialDealInput').addClass('hidden');
  $('#ph-updateQuoteDetailsForm #ph-quoteInput').val('');
  $(shoppinglistrow).remove();
  $('#ph-updateQuoteDetailsForm .ph-quote-formtextarea').val('');
});

$(document).on('click', '#ph-quoteThank-btn', function() {
  location.reload();
});

$(document).on('keyup', '.ph-quote__parent .ph-quote-formtextarea', function() {
  var $quotetextarea = $('.ph-quote__parent .ph-quote-formtextarea');
  var $quoteSendReqBtn = $('#ph-quote-sendReq-btn');
  var quoteName = $('#ph-quote__parent .ph-quoteInput').val();

  if ($quotetextarea.val() !== '' && quoteName !== '') {
    $quoteSendReqBtn.removeClass('disabled');
  } else {
    $quoteSendReqBtn.addClass('disabled');
  }
});

$(document).on('focusout', '#ph-quoteInput', function() {
  var $quoteDiv = $('.ph-quoteInput'),
      quoteRadioStr = '.ph-quoteRadioHead-add ',
      quoteNxtStr = '.ph-quote-next',
      formField = 'ph-form_field_error',
      $quotetextarea = $('.ph-quote-formtextarea'),
      $quoteSendReqBtn = $('#ph-quote-sendReq-btn'),
      shoppinglistrow = 'myshopping-list-row';

  if ($quoteDiv.val() === '') {
    $('#ph-quoteInput-field .ph-signup__error').addClass(formField);
    $('#ph-quoteInput-field .ph-contactperson__emptyvalue').removeClass('hidden');
    $(quoteRadioStr + quoteNxtStr).addClass('disabled');
  } else {
    $('#ph-quoteInput-field .ph-signup__error').removeClass(formField);
    $('#ph-quoteInput-field .ph-contactperson__emptyvalue').addClass('hidden');

    if ($(quoteRadioStr + '.ph-' + shoppinglistrow).length > 0) {
      $(quoteRadioStr + quoteNxtStr).removeClass('disabled');
    } else {
      $(quoteRadioStr + quoteNxtStr).addClass('disabled');
    }
  }

  if ($quotetextarea.val() !== '' && $quoteDiv.val() !== '') {
    $quoteSendReqBtn.removeClass('disabled');
  } else {
    $quoteSendReqBtn.addClass('disabled');
  }
});


$(document).on('click', '.ph-quote__parent #ph-quote-sendReq-btn', function() {
  var quoteName = $('#ph-quote__parent .ph-quoteInput').val(),
      customerComments = $('#ph-quote__parent .ph-quote-formtextarea').val(),
      requestedDeliveryDate = $('#ph-quote-datepicker').val(),
      entries = [],
      pointerStr = 'pointer-events',
      urlLink = window.location.href,
      trigger = 'linkCategory.clickSendQuoteRequest',
      compname = 'ph-quote-sendReq-btn',
      desc = $.trim($(this).text()),
      userEventObj = '',
      shoppinglistrow = '.ph-myshopping-list-row',
      quoteRadioHeadAdd = 'quoteRadioHead-add ';

  $('#ph-updateQuoteDetailsForm').css(pointerStr, 'none');

  $('#ph-quote__parent').find('.ph-' + quoteRadioHeadAdd + shoppinglistrow).each(function() {
    if ($('#ph-quote__parent ' + shoppinglistrow).length > 0) {
      if ($(window).width() > 700) {
        entries.push($(this).find('.ph-shoppinglistcode').html() + ':' + $(this).find('.ph-quantityDesk').val());
      } else {
        entries.push($(this).find('.ph-shoppinglistcode').html() + ':' + $(this).find('.ph-quantityMob').val());
      }
    }
  });
  $('#ph-quote__parent .ph-overlay').removeClass('ph-d-none');
  userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
  ACC.googleanalytics.gaEventsForLinks(userEventObj);

  ACC.autocomplete.quoteAjaxCall(quoteName, customerComments, requestedDeliveryDate, entries);
});

$(document).on('keyup change', '.product-code', function() {
  $('.ph-quoteexisting_product').addClass('hidden');
});

$(document).on('click', '.ph-quote__parent ul.ui-autocomplete .product', function() {
  $('.ph-quote-addprd').trigger('click');
});
$(document).on('click', '.ph-addtoquote', function() { // NOSONAR
  var $quoteDiv = $('.ph-quotesearch'),
      list = [],
      productCode = '',
      prodCodeWithoutSpace = '',
      $codeExists = false,
      shoppingrowlist = '.ph-myshopping-list-row',
      ind = 0,
      quoteexistproduct = '.ph-quoteexisting_product';

  productCode = $(this).siblings('.ph-quotesearch').val();
  prodCodeWithoutSpace = productCode.trim();

  $(shoppingrowlist).each(function() {
    list.push($(this).attr('data-code'));
  });

  for (ind; ind < list.length; ind = ind + 1) {
    if (list[ind] === prodCodeWithoutSpace) {
      $codeExists = true;
    }
  }

  if ($codeExists) {
    $(quoteexistproduct).removeClass('hidden');
    $('#product_code-1').val('');
  } else if ($quoteDiv.val() !== '') {
    $.ajax({
      url: ACC.config.encodedContextPath + '/quote/getProductData',
      data: {
        productCode: productCode
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        var productDisplayName = result.displayName,
            ctv = result.ctv,
            imgUrl = result.imageURL,
            productUrl = result.url,
            productName = result.name,
            ean = result.sapEan,
            $quoteDivInput = $('.ph-quoteInput'),
            resultProdCode = result.code,
            $codeExistsAferRes = false,
            dataArr = '',
            inx = 0,
            unitNo = result.numberContentUnits,
            unitsText = $('.ph-produnits').text(),
            quoteRadioAddNext = '.ph-quoteRadioHead-add .ph-quote-next';

        unitsText = unitsText.replace('0', unitNo);
        dataArr = [
          ean,
          unitNo,
          unitsText
        ];

        for (inx; inx < list.length; inx = inx + 1) {
          if (list[inx] === resultProdCode) {
            $codeExistsAferRes = true;
          }
        }

        if ($codeExistsAferRes) {
          $(quoteexistproduct).removeClass('hidden');
          $('#product_code-1').val('');
        } else {
          ACC.autocomplete.addProductToListQuote(resultProdCode, productDisplayName, ctv, productUrl, imgUrl, productName, dataArr);
          $quoteDiv.val('');
        }

        if ($quoteDivInput.val() !== '') {
          $(quoteRadioAddNext).removeClass('disabled');
        }
      }
    });
  }
});

$(document).on('click', '.ph-quote__reqbutton', function() {
  var urlLink = window.location.href,
      trigger = 'linkCategory.clickRequestQuotation',
      compname = 'ph-quote__reqbutton',
      desc = $.trim($(this).text()),
      userEventObj = '';

  $('.ph-quote__parent .ph-quote__reqbutton').addClass('hidden');
  $('.ph-specialDealInput').removeClass('hidden');
  $('#ph-quoteInput').focus();

  userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
  ACC.googleanalytics.gaEventsForLinks(userEventObj);
});

$(document).on('click', '#ph-quote__decbutton', function() {
  var atrQuoteId = 'quoteid',
      quoteId = $(this).attr('data-' + atrQuoteId);

  $('.ph-quote-decline-pop .ph-quoteDecline__yes').attr('data-quoteidQI', quoteId);
  $.colorbox({
    maxWidth: '520px',
    width: '100%',
    height: 'auto',
    closeButton: false,
    html: $('.ph-quote-decline-pop').html(),
    onClosed: function() {
      ACC.common.refreshScreenReaderBuffer();
    }
  });
});

$(document).on('keyup', '#cboxLoadedContent .ph-quote-formtextareaDecline', function() {
  var $quotetextarea = $('#cboxLoadedContent .ph-quote-formtextareaDecline'),
      $quoteSendReqBtn = $('#cboxLoadedContent .ph-quoteDecline__yes');

  if ($quotetextarea.val() === '') {
    $quoteSendReqBtn.addClass('disabled');
  } else {
    $quoteSendReqBtn.removeClass('disabled');
  }
});

$(document).on('click', '#cboxLoadedContent .ph-quoteDecline__yes', function() {
  var formTxt = 'formtextareaDecline',
      txtReason = $('#cboxLoadedContent .ph-quote-' + formTxt).val(),
      quoteId = $(this).attr('data-quoteidQI'),
      urlLink = window.location.href,
      trigger = 'linkCategory.clickDeclineQuotation',
      compname = 'ph-quoteDecline__yes',
      desc = $.trim($(this).text()) + ' - ' + quoteId,
      userEventObj = '';

  userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
  ACC.googleanalytics.gaEventsForLinks(userEventObj);

  $.ajax({
    url: ACC.config.encodedContextPath + '/quote/declineQuote',
    data: {
      quoteId: quoteId,
      reasonCode: txtReason
    },
    type: 'POST',
    datatype: 'json',
    success: function() {
      location.reload();
    }
  });
});

ACC.quotation = {
  isblockedmsg: '.ph-isblocked-msg-',
  getBlockedProductList: function() {
    var $blockedProducts = $('.ph-blockedlist'),
        blockProductCodes = [];

    $.each($blockedProducts, function() {
      blockProductCodes.push($(this).attr('data-blockedprdcode'));
    });

    return blockProductCodes;
  },

  checkForBlockedProducts: function(productCode) {
    var blockProductCodes = '',
        disableBtn = 'ph-disable-button';

    blockProductCodes = ACC.common.getBlockedProductList();

    if (blockProductCodes.includes(productCode)) {
      $(ACC.quotation.isblockedmsg + productCode).removeClass('hidden');
      $(ACC.quotation.isblockedmsg + productCode).next().addClass('hidden');
      $('#row' + productCode).find('.ph-list_plusminus').addClass(disableBtn);
      $('.ph-qty-' + productCode).val('0').addClass(disableBtn);
    }
  },

  checkForBlockedProductsOnLoad: function() {
    var listProducts = '',
        $listProducts = $('.ph-prod__codes'),
        $blockedProducts = $('.ph-blockedlist'),
        listName = '',
        disableBtn = 'ph-disable-button',
        blockProductCodes = [];

    $.each($blockedProducts, function() {
      blockProductCodes.push($(this).attr('data-blockedprdcode'));
    });

    $.each($listProducts, function() {
      listProducts = $(this).val();
      listName = $(this).attr('data-listname');

      if (blockProductCodes.includes(listProducts)) {
        $('.ph-qty-' + listProducts).val('0').addClass(disableBtn);
        $('.' + listName + '-' + listProducts).addClass(disableBtn);
        $('.ph-qtyminus-' + listProducts).addClass(disableBtn);
        $(ACC.quotation.isblockedmsg + listProducts).removeClass('hidden');
        $(ACC.quotation.isblockedmsg + listProducts).next().addClass('hidden');
      }
    });
  }
};
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
/* eslint-enable max-lines */
/* eslint-enable radix */
/* eslint-enable max-statements*/
/* eslint-enable no-negated-condition*/
/* eslint-enable no-use-before-define*/
/* eslint-enable xss/no-mixed-html*/
